<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-card :bordered="false">
        <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('问题分类')" prop="title">
                <a-select placeholder="请选择状态" style="width: 100%" v-model="queryParam.problemTypeId" allowClear>
                  <a-select-option
                    v-for="(item, index) in helpTypeList"
                    :value="item.id"
                    :key="index">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('常见问题标题')" prop="title">
                <a-input v-model="queryParam.title" @pressEnter="handleQuery" :maxLength="32" :placeholder="$t('请输入')+$t('常见问题标题')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select placeholder="请选择状态" style="width: 100%" v-model="queryParam.status" allowClear>
                  <a-select-option
                    v-for="(item, index) in this.customDict.StatusEnum"
                    :value="item.type"
                    :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :customRow="loadCustomRow"
        :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'radio',  onChange: onSelectChange}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.StatusEnum" :value="record.status"/>
        </span>
        <span slot="problemTypeId" slot-scope="text, record">
          {{ getTypeById(record.problemTypeId) }}
        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-modal>
</template>

<script>
import {pageSelectGoods,listSelectGoods} from '@/api/goods/goods'
import {platformCategoryList} from '@/api/goods/category'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {tableMixin} from '@/store/table-mixin'
import {pageProblem} from "@/api/help/problem";
import {listType} from "@/api/help/type";


export default {
  name: 'NewsSelectForm',
  props: {},
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      goodsType:undefined,
      activeKey: 'first',
      pageSizeOptions: ['10', '20', '50', '100'],
      limitNum: undefined,
      selectedRowKeys: [],
      selectedRows: [],
      categoryList: [],
      cateOptions: [],
      helpTypeList: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      idText:null,
      // 查询参数
      queryParam: {
        goodsCode: null,
        goodsName: null,
        excludeId: undefined,
        goodsType:undefined,
        merchantIdList: [],
        categoryId: null,
        orderByGoodsIdList:undefined,
        shopId: null,
        shopCategoryId: null,
        brandId: null,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        starName: null,
        prodArea: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('问题分类'),
          scopedSlots: { customRender: 'problemTypeId' },
          dataIndex: 'problemTypeId',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('常见问题标题'),
          dataIndex: 'title',
          ellipsis: true,
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: this.$t('常见问题简述'),
          dataIndex: 'sketch',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('显示顺序'),
          dataIndex: 'orderSort',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态'),
          scopedSlots: { customRender: 'status' },
          dataIndex: 'status',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
      ]
    };
  },
  filters: {},
  created() {
    this.getHelpTypeList()
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.activeKey = index
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },

    /**
     *
     * @param id
     */
    openNews(id,) {
      if (id) {
        this.selectedRowKeys = [id]
        this.queryParam.orderByGoodsIdList = [id];
      }
      this.getList();
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('newsSelect', this.selectedRows)
      this.resetQueryForm()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQueryForm()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageProblem(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getTypeById(id) {
      if (!id) {
        return ''
      }
      const cateInfo = this.helpTypeList.find(e => e.id === id)
      if (cateInfo) {
        return cateInfo.title
      } else {
        return ''
      }
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQueryForm() {
      this.queryParam = {
        problemTypeId: undefined,
        title: undefined,
        sketch: undefined,
        contentInfo: undefined,
        orderSort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
    },

    /** 重置按钮操作 */
    resetQuery () {
      this.resetQueryForm()
      this.handleQuery()
    },
    getHelpTypeList () {
      listType({}).then(response => {
        this.helpTypeList = response.data
      })
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            // 记录为disabled则直接返回，默认为不可选
            if (this.selectedRowKeys.find(e=>e.id===record.id)) {
              return;
            }
            let selectedRowKeys  = [record.id]
            let selectedRows =[record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          },
          dblclick: () => {
            this.onOk()
          },
        }
      }
    },
  }
}
</script>
